import { render } from "./AdmEmptyState.vue?vue&type=template&id=1f5e8201&scoped=true"
import script from "./AdmEmptyState.vue?vue&type=script&lang=js"
export * from "./AdmEmptyState.vue?vue&type=script&lang=js"

import "./AdmEmptyState.vue?vue&type=style&index=0&id=1f5e8201&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5e8201"]])

export default __exports__